<template>
  <div class="index-banner banner-container">
    <swiper
      :modules="modules"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      :pagination="{ clickable: true }"
    >
      <swiper-slide>
        <div class="cont">
          <div class="common-container">
            <h2 class="wow bounceInUpSlow" data-wow-delay="0.25s">
              云+端一站式开放平台
            </h2>
            <h5 class="wow bounceInUpSlow" data-wow-delay="0.35s">
              为你提供多维度的开放能力
            </h5>
            <a
              class="common-but waves wow bounceInUpSlow"
              v-waves
              data-wow-delay="0.45s"
              href="##"
              >立即入驻</a
            >
          </div>
        </div>
        <img src="@/assets/images/banner01.png" alt />
      </swiper-slide>
      <swiper-slide>
        <div class="cont">
          <div class="common-container">
            <h2>新媒体创作平台</h2>
            <h5>为您提供创意采集、文章AI工具、及多渠道发稿能力</h5>
            <a class="common-but waves" v-waves href="##">立即入驻</a>
          </div>
        </div>
        <img src="@/assets/images/banner02.png" alt />
      </swiper-slide>
      <swiper-slide>
        <div class="cont">
          <div class="common-container">
            <h2>智能媒体生产平台</h2>
            <h5>赋能用户全链路业务流程、多种智能能力提高内容生产效率...</h5>
            <a class="common-but waves" v-waves href="##">立即入驻</a>
          </div>
        </div>
        <img src="@/assets/images/banner03.png" alt />
      </swiper-slide>
    </swiper>
    <div class="notice">
      <div class="common-container">
        <div class="title cover">
          <img src="@/assets/images/new-tit.png" alt />
          <i class="iconfont icon-notice"></i>
        </div>
        <div class="list-box">
          <transition name="fade">
            <ul class="list" v-if="noticeScroll">
              <li class="waves-click">
                <a href="https://open.shmedia.tech/##">
                  <p><i class="new-icon">NEW</i>怡动助力静安APP商城全新改版</p>
                  <span class="time">{{ newDate }}</span>
                </a>
              </li>
              <li class="waves-click">
                <a href="https://open.shmedia.tech/##">
                  <p><i class="new-icon">NEW</i>融媒APP适老化方案在上海落地</p>
                  <span class="time">{{ newDate }}</span>
                </a>
              </li>
              <li class="waves-click">
                <a href="https://open.shmedia.tech/##">
                  <p>活动运营平台新玩法，持续带来客户价值</p>
                  <span class="time">{{ newDate }}</span>
                </a>
              </li>
            </ul>
            <ul class="list" v-else>
              <li class="waves-click">
                <a href="https://open.shmedia.tech/##">
                  <p>移动采编助力提升媒体的传播力、影响力</p>
                  <span class="time">{{ newDate }}</span>
                </a>
              </li>
              <li class="waves-click">
                <a href="https://open.shmedia.tech/##">
                  <p>全新多媒体处理解决方案惊艳亮相</p>
                  <span class="time">{{ newDate }}</span>
                </a>
              </li>
              <li class="waves-click">
                <a href="https://open.shmedia.tech/##">
                  <p>“一键搞定”，全媒体矩阵管理即将推出</p>
                  <span class="time">{{ newDate }}</span>
                </a>
              </li>
            </ul>
          </transition>
        </div>

        <div class="more" v-if="false">
          <a href="https://open.shmedia.tech/##">
            更多
            <i class="iconfont icon-more"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js";
import { ref, onUnmounted } from "vue";
import { getNotice } from "@/common/api";
import dayjs from "dayjs";
const onSwiper = (swiper) => {
  // console.log(swiper);
};
const onSlideChange = () => {
  // console.log('slide change');
};
const noticeScroll = ref(true);
const newDate = ref(dayjs().format("YYYY-MM-DD"));
const timer = setInterval(() => {
  noticeScroll.value = !noticeScroll.value;
}, 2600);
onUnmounted(() => {
  clearInterval(timer);
});
const getnews = () => {
  getNotice({
    data: {
      pageNo: 1,
      pageSize: 5,
    },
    success: (res) => {
      console.log(res);
    },
    fail: (err) => {
      console.log(err, "err");
    },
  });
};
getnews();
const modules = ref([Pagination]);
</script>
<style lang="less">
.index-banner {
  position: relative;
}
.fade-enter-active {
  // transform: translateY(-20px);
  transition: all 0.5s ease-in-out;
}
.fade-leave-active {
  transform: translateY(-30px);
  transition: all 0.5s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0.5;
  // transform: translateY(0);
}
</style>
